import css from 'styled-jsx/css';
import colors from '../../../config/colors';

export const imageWithTextStyle = css`
	.card {
		padding: 1rem;
		margin: 0.7rem 1rem;
	}

	.text-center {
		text-align: center;
	}

	.image-title {
		height: 2.75rem;
		display:flex;
		flex-direction: column;
	}

	.title {
		font-size: 1rem;
		line-height: 1.375rem;
		letter-spacing: normal;
		color: #08081B;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.image {
		display: block;
		width: 11.25rem;
		height: 11.25rem;
		margin: auto;
		object-fit:contain;
	}
	
	.custom-image{
		display:block
		margin: 0 auto;
		object-fit:contain;
		background-size:cover;
	}
	.custom-image-section{
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center;
		margin: 0 auto;
	}
	.color-label {
		color:${colors.Grey60};
		font-family: Roboto Regular;
		font-size: 0.875rem;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
	}
`;
